module.exports = __webpack_public_path__ + "static/media/ppc.40531ccf.svg";